import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  orders: [],
  order: {
    doctor_name: '',
    id: 0,
    patient: '',
    price: '',
    paid: '',
    technic_name: '',
    url_photo: '',
    color: '',
  },

  type_pay: 'non-cash',
  photos: [],
  audios: [],
  files: [],
  comments: [],
  pacient: '',
  color: '',
  price: 0,
  paid: 0,
  technic_id: 0,

  showOrderCard: false,
  doctor_name: '',
  doctorCompany: ''
};

export const orderSlice = createSlice({
  name: 'order',
  initialState,
  reducers: {
    setDoctorCompany: (state, action) => {
      state.doctorCompany = action.payload
    },
    setDoctorName: (state, action) => {
      state.doctor_name = action.payload
    },
    setFiles: (state, action) => {
      state.files = action.payload
    },
    setPhotos: (state, action) => {
      state.photos = action.payload
    },
    setShowOrderCard: (state, action) => {
      state.showOrderCard = action.payload
    },
    setTechnicId: (state, action) => {
      state.technic_id = action.payload
    },
    setComments: (state, action) => {
      state.comments = action.payload
    },
    setTypePaid: (state, action) => {
      state.type_pay = action.payload
    },
    setPaid: (state, action) => {
      state.paid = action.payload
    },
    setAudios: (state, action) => {
      state.audios = action.payload
    },
    setOrders: (state, action) => {
      state.orders = action.payload
    },
    setOrder: (state, action) => {
      state.order = action.payload
    },
    setPacient: (state, action) => {
      state.pacient = action.payload
    },
    setColor: (state, action) => {
      state.color = action.payload
    },
    setPrice: (state, action) => {
      state.price = action.payload
    },
  },
});

export const {setFiles, setDoctorCompany, setDoctorName, setPhotos, setShowOrderCard, setTechnicId, setComments, setTypePaid, setPaid, setAudios, setOrders, setOrder, setPacient, setColor, setPrice } = orderSlice.actions;

export const selectFiles = (state) => state.order.files;
export const selectOrders = (state) => state.order.orders;
export const selectOrder = (state) => state.order.order;
export const selectPacient = (state) => state.order.pacient;
export const selectColor = (state) => state.order.color;
export const selectPrice = (state) => state.order.price;
export const selectAudios = (state) => state.order.audios;
export const selectPaid = (state) => state.order.paid;
export const selectTypePaid = (state) => state.order.type_pay;
export const selectComments = (state) => state.order.comments;
export const selectTechnicId = (state) => state.order.technic_id;
export const selectShowOrderCard = (state) => state.order.showOrderCard;
export const selectPhotos = (state) => state.order.photos;
export const selectDoctorName = (state) => state.order.doctor_name;
export const selectDoctorCompany = (state) => state.order.doctorCompany;

export default orderSlice.reducer;
